<template>
    <v-data-table :items="dashboard" :headers="dashboardHeaders" :loading="loading" disable-sort disable-pagination hide-default-footer class="elevation-1 ma-8">
        <template v-slot:item.issue="{ item }">
            <v-col>{{ item.issue.count.format() }}건({{ item.issue.price.format() }}원)</v-col>
        </template>
        <template v-slot:item.pay="{ item }">
            <v-col>{{ item.pay.count.format() }}건({{ item.pay.price.format() }}원)</v-col>
        </template>
        <template v-slot:item.cancel="{ item }">
            <v-col>{{ item.cancel.count.format() }}건({{ item.cancel.price.format() }}원)</v-col>
        </template>
    </v-data-table>
</template>

<script>
import api from "@/api";
import dayjs from "dayjs";
import levels from "@/assets/data/levels.json";

export default {
    data() {
        return {
            loading: true,

            levels,

            filter: {
                month: dayjs().format("YYYY-MM")
            },

            dashboad: [],
            dashboardHeaders: [
                {
                    text: "권종",
                    align: "center",
                    value: "level.name"
                },
                {
                    text: "발행",
                    align: "center",
                    value: "issue"
                },
                {
                    text: "사용",
                    align: "center",
                    value: "pay"
                },
                {
                    text: "폐기",
                    align: "center",
                    value: "cancel"
                },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            this.loading = true;
            var { dashboard } = await api.console.pins.dashboard({
                params: this.filter
            });

            dashboard = dashboard.map(data => ({ ...data, level: levels.find(level => level.code == data.lv) }));

            this.dashboard = dashboard.sort((a, b) => {
                if(a.level.value > b.level.value) return -1;
                if(a.level.value < b.level.value) return 1;
                return 0; 
            });
            this.loading = false;
        },
    }
}
</script>
